var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F7F3EF",
    stroke: "#602131"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1420_3128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5 50C57.2859 50 62.7857 44.6281 62.7857 38C62.7857 31.3719 57.2859 26 50.5 26C43.7141 26 38.2143 31.3719 38.2143 38C38.2143 44.6281 43.7141 50 50.5 50ZM59.1 53H57.4971C55.3663 53.9562 52.9955 54.5 50.5 54.5C48.0045 54.5 45.6433 53.9562 43.5029 53H41.9C34.7781 53 29 58.6437 29 65.6V69.5C29 71.9844 31.0636 74 33.6071 74H67.3929C69.9364 74 72 71.9844 72 69.5V65.6C72 58.6437 66.2219 53 59.1 53Z",
    fill: "#602131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1420_3128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 48,
    fill: "white",
    transform: "translate(29 26)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.dbdcb4c252d174e040aacb4d2380e7cf.svg";
export { ForwardRef as ReactComponent };